//
// Copyright 2020 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import MessageDialog, { useMessageDialog } from "./MessageDialog";

/**
 * Hook which returns props required by the ErrorMessageDialog as well as a function to set an error message.
 */
export function useErrorMessageDialog() {
  return useMessageDialog();
}
export default function ErrorMessageDialog(props) {
  return /*#__PURE__*/React.createElement(MessageDialog, Object.assign({
    error: true
  }, props));
}